import { render, staticRenderFns } from "./xunfangInfo.vue?vue&type=template&id=35596ee0&scoped=true"
import script from "./xunfangInfo.vue?vue&type=script&lang=js"
export * from "./xunfangInfo.vue?vue&type=script&lang=js"
import style0 from "./xunfangInfo.vue?vue&type=style&index=0&id=35596ee0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX-JYJ\\WEB\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35596ee0",
  null
  
)

export default component.exports